import type { RefObject } from 'react'
import { useLayoutEffect } from 'react'
import { useSetFonts } from './use-set-fonts'

export const useFixFontsForIframe = ({
  iframeRef,
}: {
  iframeRef: RefObject<HTMLIFrameElement>
}): void => {
  const { fontStyle, fontFamily } = useSetFonts()

  useLayoutEffect(() => {
    if (fontFamily && fontStyle && iframeRef.current?.contentDocument?.body) {
      const style = iframeRef.current?.contentDocument.createElement('style')
      style.textContent = fontStyle
      iframeRef.current.contentDocument.head.append(style)

      iframeRef.current.contentDocument.body.style.fontFamily = fontFamily
    }
  }, [iframeRef, fontFamily, fontStyle])
}
